module.exports = function findRestrictionMessage(isRestricted) {
	switch (isRestricted) {
		case null:
			//NO RESTRICTION SET
			return "";
		case 0:
			// UNLOCKED BY TIME
			return ["For immediate release", "green"];
		case 1:
			// RESTRICTED BY CHECKBOX
			return ["Restricted content", "orange"];
		case 2:
			// RESTRICTED BY TIME
			return ["Restricted content", "orange"];
		case false:
			//UNLOCKED BY TOKEN
			return ["Private content", "gray"];
		default:
			return "";
	}
};
